import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { put, takeLatest, select } from 'redux-saga/effects'
import { ActionWithPayload } from '../../../../../@Common/Interfaces/ActionWithPayload'
import { MenuItemModel } from '../models/MenuItemModel'
import { getMenuItems } from './MenuActions'

export const actionTypes = {
    MenuItemsRequested: '[Request Menu Items] Action',
    MenuItemsLoaded: '[Loaded Menu Items] API'
}

export interface IMenuItemState {
    menuItems?: MenuItemModel[]
}

const initialMenuItemState: IMenuItemState = {
    menuItems: undefined
}

export const reducer = persistReducer(
    { storage, key: 'icon-core-menu-tem', whitelist: ['menuItems'] },
    (state: IMenuItemState = initialMenuItemState, action: ActionWithPayload<IMenuItemState>) => {
        switch (action.type) {
            case actionTypes.MenuItemsLoaded: {
                return {
                    ...state,
                    menuItems: action.payload?.menuItems
                };
            }

            default:
                return state
        }
    }
)

export const actions = {
    requestMenuItems: () => ({
        type: actionTypes.MenuItemsRequested,
    }),
    fulfillMenuItems: (menuItems: MenuItemModel[]) => ({ type: actionTypes.MenuItemsLoaded, payload: { menuItems } })
}

export function* saga() {
    yield takeLatest(actionTypes.MenuItemsRequested, function* menuItemsRequested() {
        const menuItems = yield getMenuItems();
        yield put(actions.fulfillMenuItems(menuItems));
    })
}